



















































import $router from "@/router";
import store from "../store";
import LoadingScreen from "@/components/LoadingScreen.vue";
import CustomRadio from "@/components/CustomRadio.vue";
import Vue from "vue";
import { FooterSettings } from "@/models";

const footerSettings: FooterSettings = {
  prevText: "questionnaire.footer.prev",
  prevIcon: "fas fa-chevron-left",
  prevAction: function() {
    store.commit("setLoading", {
      loading: true,
      loadingText: "",
      transition: "slide-right"
    });
    $router.push("/instructions");
  },
  prevVisible: true,
  prevEnabled: true,
  nextText: "questionnaire.footer.next",
  nextIcon: "fas fa-chevron-right",
  nextAction: function() {
    store.commit("setLoading", {
      loading: true,
      loadingText: "",
      transition: "slide-left"
    });
    $router.push("/before-after");
  },
  nextVisible: true,
  nextEnabled: true
};

export default Vue.extend({
  name: "WrinkleSelection",
  components: { LoadingScreen, CustomRadio },
  data() {
    return {
      wrinkleSelect: "1"
    };
  },
  watch: {
    wrinkleSelect(): void {
      store.commit("setWrinkles", +this.wrinkleSelect);
    }
  },
  mounted() {
    store.commit("changeFooter", footerSettings);
  }
});
